/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-CPC Export API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { CatalogProductsExportRestDto } from '../models';
/**
 * ExportAPIApi - axios parameter creator
 * @export
 */
export const ExportAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.CPC.EXPORT.01 Export customer catalog details.
         * @param {CatalogProductsExportRestDto} body 
         * @param {string} accept text/csv OR application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
         * @param {string} catalog_customer_code Identifies the product catalog that is being accessed.
         * @param {string} export_type_code The type of document that is being handled.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportCustomerCatalogDetails: async (body: CatalogProductsExportRestDto, accept: string, catalog_customer_code: string, export_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling exportCustomerCatalogDetails.');
            }
            // verify required parameter 'accept' is not null or undefined
            if (accept === null || accept === undefined) {
                throw new RequiredError('accept','Required parameter accept was null or undefined when calling exportCustomerCatalogDetails.');
            }
            // verify required parameter 'catalog_customer_code' is not null or undefined
            if (catalog_customer_code === null || catalog_customer_code === undefined) {
                throw new RequiredError('catalog_customer_code','Required parameter catalog_customer_code was null or undefined when calling exportCustomerCatalogDetails.');
            }
            // verify required parameter 'export_type_code' is not null or undefined
            if (export_type_code === null || export_type_code === undefined) {
                throw new RequiredError('export_type_code','Required parameter export_type_code was null or undefined when calling exportCustomerCatalogDetails.');
            }
            const localVarPath = `/export/v1/export_type/{export_type_code}/catalog/{catalog_customer_code}/product/`
                .replace(`{${"catalog_customer_code"}}`, encodeURIComponent(String(catalog_customer_code)))
                .replace(`{${"export_type_code"}}`, encodeURIComponent(String(export_type_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (accept !== undefined && accept !== null) {
                localVarHeaderParameter['Accept'] = String(accept);
            }

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExportAPIApi - functional programming interface
 * @export
 */
export const ExportAPIApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.CPC.EXPORT.01 Export customer catalog details.
         * @param {CatalogProductsExportRestDto} body 
         * @param {string} accept text/csv OR application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
         * @param {string} catalog_customer_code Identifies the product catalog that is being accessed.
         * @param {string} export_type_code The type of document that is being handled.
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportCustomerCatalogDetails(_axios: AxiosInstance, body: CatalogProductsExportRestDto, accept: string, catalog_customer_code: string, export_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ExportAPIApiAxiosParamCreator(configuration).exportCustomerCatalogDetails(body, accept, catalog_customer_code, export_type_code, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExportAPIApi - object-oriented interface
 * @export
 * @class ExportAPIApi
 * @extends {BaseAPI}
 */
export class ExportAPIApi extends BaseAPI {
    /**
     * 
     * @summary REST.API.CPC.EXPORT.01 Export customer catalog details.
     * @param {CatalogProductsExportRestDto} body 
     * @param {string} accept text/csv OR application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
     * @param {string} catalog_customer_code Identifies the product catalog that is being accessed.
     * @param {string} export_type_code The type of document that is being handled.
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExportAPIApi
     */
     public exportCustomerCatalogDetails(body: CatalogProductsExportRestDto, accept: string, catalog_customer_code: string, export_type_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return ExportAPIApiFp(this.configuration).exportCustomerCatalogDetails(this.axios, body, accept, catalog_customer_code, export_type_code, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

}
